import React, { useEffect, useState } from "react";
import Card from "./components/card/Card2";
import styled from "styled-components";
import "bootstrap/dist/css/bootstrap.min.css";
import { useSpring, animated } from "react-spring";
import { useTranslation } from "react-i18next";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`;

const CardWrapper = styled(animated.div)`
  perspective: 1000px;
  margin: 20px;
`;

const CardContent = styled.div`
  background: ${(props) => props.bg};
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
`;

const CardButton = styled.button`
  margin-top: 20px;
  padding: 10px 20px;
  background-color: ${(props) => props.color};
  border: none;
  border-radius: 5px;
  color: white;
  cursor: pointer;
`;

const Dashboard2 = () => {
  const { t } = useTranslation();
  const [props, set] = useSpring(() => ({
    transform: "rotateY(0deg) rotateX(0deg)",
    config: { mass: 5, tension: 350, friction: 40 },
  }));
  const [checkerStatus, setCheckerStatus] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("trackingIDFromServer") === "null") {
      setCheckerStatus(false);
      setIsDisabled(true);
    } else {
      setCheckerStatus(true);
      setIsDisabled(false);
    }
  }, []);

  console.log("checkerStatus", checkerStatus);

  return (
    <Container>
      <div className="container">
        {checkerStatus ? (
          <div className="col-12 col-md-12 mb-3">
            <Card
              title={t("review")}
              bg="rgba(209, 30, 53, 0.30)"
              body={t("view_info")}
              btn_text={t("view_details")}
              btn="red"
              btn_link="/view-details"
            />
          </div>
        ) : (
          // <div className="row">
          <div className="col-12 col-md-12 mb-3">
            <Card
              bg="rgba(32, 172, 98, 0.28)"
              title={t("new_resident_enrolment")}
              btn="green"
              body={t("preenrol_info_card")}
              btn_text={t("start_enrolment_btn")}
              btn_link="/biodata"
            />
          </div>

          //   <div className="col-12 col-md-6 mb-3">
          //     <Card
          //       title="REVIEW"
          //       bg="rgba(209, 30, 53, 0.30)"
          //       body="If you have registered and you want to view your information, click the button"
          //       btn_text="View Details"
          //       btn="red"
          //       btn_link="/view-details"
          //     />
          //   </div>
          // </div>
        )}
      </div>
    </Container>
  );
};

export default Dashboard2;
